window.$ = window.jQuery = require('jquery');

import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

window.gsap           = gsap;
window.ScrollTrigger  = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;


ScrollTrigger.matchMedia({
    "(min-width: 1280px)": function() {

    },
    "(max-width:1024px)": function() {
        let mbmou1 = gsap.timeline();
        ScrollTrigger.create({
            animation: mbmou1,
            trigger: ".index-mball",
            start: "0 top",
            end: "200 top",
            scrub: 3,
        });
        mbmou1.fromTo(".monr1m", {marginTop: '0vw'},{marginTop:'-6vw'}, 0)

        let mbmou = gsap.timeline();
        ScrollTrigger.create({
            animation: mbmou,
            trigger: ".index-mball",
            start: "80 top",
            end: "350 top",
            scrub: 3,
        });
        mbmou.fromTo(".mon-lm1", {bottom: '-5vw'},{bottom:'8vw'}, 0)
        mbmou.fromTo(".mon-lm2", {bottom: '-5vw'},{bottom:'5vw'}, 0)
        mbmou.fromTo(".mon-rm1", {bottom: '-10vw'},{bottom:'5vw'}, 0)
        mbmou.fromTo(".mon-rm2", {bottom: '-5vw'},{bottom:'5vw'}, 0)
        mbmou.fromTo(".monr1m", {marginTop: '0vw'},{marginTop:'-3vw'}, 0)

        let circlipm = gsap.timeline();
        ScrollTrigger.create({
            animation: circlipm,
            trigger: ".index-mball",
            start: "900 top",
            end: "1200 top",
            scrub: 3,
        });
        circlipm.fromTo(".cirin", {top: '0vw'},{top:'5vw'}, 0)

        ScrollTrigger.create({
            trigger: ".mb-section2-why",
            start: "-90% top",
            onEnter:function () {
                $('.mb-section2-why').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section3-web",
            start: "-80% top",
            onEnter:function () {
                $('.mb-section3-web').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section3-web",
            start: "-100 top",
            onEnter:function () {
                $('.floattop1').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section3-web",
            start: "100 top",
            onEnter:function () {
                $('.floattop2').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section3-web",
            start: "200 top",
            onEnter:function () {
                $('.floattop3').addClass('vivi')
            }
        });

        let mbdranbg = gsap.timeline();
        ScrollTrigger.create({
            animation: mbdranbg,
            trigger: ".mb-section4-one",
            start: "-500 top",
            end: "350 top",
            scrub: 3,
        });
        mbdranbg.fromTo(".imgaream", {top: '-10vw'},{top:'0vw'}, 0)

        ScrollTrigger.create({
            trigger: ".mb-section4-one",
            start: "-80% top",
            onEnter:function () {
                $('.mb-section4-one').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section5-work",
            start: "-300 top",
            onEnter:function () {
                $('.mb-section5-work').addClass('vivi')
            }
        });

        ScrollTrigger.create({
            trigger: ".mb-section6-app",
            start: "-200 top",
            onEnter:function () {
                $('.mb-section6-app').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".app-content",
            start: "-200 top",
            onEnter:function () {
                $('.app-content').addClass('vivi')
            }
        });

        let section6m = gsap.timeline();
        ScrollTrigger.create({
            animation: section6m,
            trigger: ".mb-section6-app",
            start: "-600 top",
            end: "400 top",
            scrub: 3,
        });
        section6m.fromTo(".mb-section6-app .sun-bg", {top: '15vw'},{top:'0vw'}, 0)
        section6m.fromTo(".mb-section6-app .app-build", {top: '12vw'},{top:25}, 0)
        section6m.fromTo(".mb-section6-app .bg", {bottom: '20vw'},{bottom:'6vw'}, 0)

        ScrollTrigger.create({
            trigger: ".mb-section7-line",
            start: "-300 top",
            onEnter:function () {
                $('.mb-section7-line').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section8-client",
            start: "-300 top",
            onEnter:function () {
                $('.mb-section8-client').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section9-contact",
            start: "-300 top",
            onEnter:function () {
                $('.mb-section9-contact').addClass('vivi')
            }
        });
    }
});

